<template>
  <main class="position-relative">
    <LmLoading v-if="isLoading" />
    <template v-else>
      <b-row no-gutters>
        <!-- When -->
        <b-col cols="6" class="divider">
          <div
            class="px-4 my-5 d-flex flex-column align-items-center justify-content-center position-relative"
          >

            <div class="title mb-5">
              Cuando <span>pase esto</span>
            </div>

            <hr class="line">

            <b-card class="w-75">
              <!-- Listener -->
              <LmTreeSelect
                class="w-100 mb-3"
                placeholder="Tipo de trámite"
                path-to-get-async-options="/processtypes/predictive"
                async
                v-model="form.when.listener"
              />

              <!-- Event -->
              <LmTreeSelect
                class="w-100 mb-3"
                placeholder="Evento"
                :options="config.whenOptions"
                v-model="form.when.event"
              />

              <!-- Event props -->
              <Component
                v-if="form.when.event"
                :value="form.when.details"
                :is="form.when.event.component"
                @change="form.when.details = $event"
              />
            </b-card>

          </div>
        </b-col>

        <a-icon type="right-circle" class="divider-arrow-icon" />

        <!-- Do -->
        <b-col cols="6">
          <div
            class="px-4 my-5 d-flex flex-column align-items-center justify-content-center position-relative"
          >

            <div class="title mb-5">
              Entonces <span>haz esta acción</span>
            </div>

            <hr class="line">

            <b-card class="w-75">
              <!-- Event -->
              <LmTreeSelect
                class="w-100 mb-3"
                placeholder="Acción"
                :options="config.doOptions"
                v-model="form.do.event"
              />

              <!-- Event props -->
              <Component
                v-if="form.do.event"
                :value="form.do.details"
                :is="form.do.event.component"
                @change="form.do.details = $event"
              />
            </b-card>

          </div>
        </b-col>
      </b-row>

      <a-button
        type="primary"
        shape="round"
        size="large"
        class="save-button"
        @click="onSave"
      >
        Guardar
      </a-button>
    </template>
  </main>
</template>

<script>
import commonsApi from '@/api/commons'
import { defineComponent } from 'vue'
import config from '@/helpers/LmAutomation'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmDropdown from '@/components/LmDropdown'
import lmToasts from '@/mixins/lmToasts'

// Components
// When
import ProcessStatusChange from '@/components/automation/when/ProcessStatusChange'
// Do
import ProcessDocumentationNeeded from '@/components/automation/do/ProcessDocumentationNeeded'

export default defineComponent({
  mixins: [lmToasts],
  components: {
    LmDropdown,
    ProcessStatusChange,
    ProcessDocumentationNeeded,
    LmTreeSelect
  },
  props: {
    isOnEditMode: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isLoading: false,
    config: config,
    form: {
      when: {
        listener: null,
        event: null,
        details: null
      },
      do: {
        event: null,
        details: null
      }
    }
  }),
  computed: {
    id () {
      return this.$route.params.id
    },
    service () {
      return this.$route.params.service
    }
  },
  methods: {
    async onSave () {
      try {
        this.isLoading = true
        let response
        if (this.isOnEditMode) {
          response = await commonsApi.axiosPutWrapper('/automation/' + this.id, {
            service: this.service,
            ...this.form
          })
        } else {
          response = await commonsApi.axiosPostWrapper('/automation', {
            service: this.service,
            ...this.form
          })
        }
        this.lmToastSuccessMessage(
          'Se guardó correctamente'
        )
        if (!this.isOnEditMode) {
          this.$router.push(`/automatizacion/${this.service}/editar/${response.data._id}`)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    }
  },
  async created () {
    if (this.isOnEditMode) {
      this.isLoading = true
      const response = await commonsApi.axiosGetWrapper('/automation/' + this.id)
      this.form = response.data
      this.isLoading = false
    }
  }
})
</script>

<style scoped>
.save-button {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 20px;
}
.col-6 {
  min-height: calc(100vh - 130px);
}
.divider {
  border-right: 1px solid #e5e3e3;
}
.line {
  background-color: #e5e3e3;
  transform: rotate(90deg);
  width: 2.5rem;
  position: absolute;
  top: 86px;
}
.divider-arrow-icon {
  color: #e5e3e3;
  background-color: white;
  font-size: 4rem;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.title {
  display: inline-block;
  border-radius: 24px;
  background-color: white;
  border: 1px solid #ffffff7b;
  padding: .8rem 3rem;
  filter: drop-shadow(5px 5px 10px rgb(46, 46, 46, 0.12));
  font-size: 1.4rem;
  font-weight: 700;
}
.title > span {
  font-weight: 500;
  letter-spacing: 1px;
  display: block;
  font-size: .7rem;
  color: gray;
  text-transform: uppercase;
}
</style>
